import { defineComponent } from 'vue'
import { mapActions, mapState } from 'vuex'
import { IssueDetailActions, IssueDetailModuleState } from '~/store/issue/detail'

export default defineComponent({
  name: 'IssueDetailMixin',

  computed: {
    ...(mapState<IssueDetailModuleState>('issue/detail', {
      issue: (state: IssueDetailModuleState) => state.issue,
      singleIssue: (state: IssueDetailModuleState) => state.singleIssue,
      silenceRules: (state: IssueDetailModuleState) => state.silenceRules,
      checkIssues: (state: IssueDetailModuleState) => state.checkIssues
    }) as {
      issue: () => IssueDetailModuleState['issue']
      singleIssue: () => IssueDetailModuleState['singleIssue']
      silenceRules: () => IssueDetailModuleState['silenceRules']
      checkIssues: () => IssueDetailModuleState['checkIssues']
    })
  },

  methods: {
    ...mapActions('issue/detail', {
      fetchIssueDetails: IssueDetailActions.FETCH_ISSUE,
      fetchSilenceRules: IssueDetailActions.FETCH_SILENCE_RULES,
      fetchSingleIssue: IssueDetailActions.FETCH_SINGLE_ISSUE,
      fetchIssueChildren: IssueDetailActions.FETCH_ISSUE_CHILDREN,
      ignoreIssueFilePattern: IssueDetailActions.IGNORE_ISSUE_FILE_PATTERN,
      ignoreIssueTestPattern: IssueDetailActions.IGNORE_ISSUE_TEST_PATTERN,
      ignoreIssueRepository: IssueDetailActions.IGNORE_ISSUE_REPOSITORY,
      ignoreIssueForFile: IssueDetailActions.IGNORE_ISSUE_FOR_FILE,
      updateIgnoreCheckIssue: IssueDetailActions.IGNORE_ISSUE_CHECK_ISSUE,
      ignoreIssueFalsePositive: IssueDetailActions.IGNORE_ISSUE_FALSE_POSITIVE
    })
  }
})
